module.exports = __webpack_public_path__ + "static/media/homs.2d9886da.gif";